import React, { useEffect, useState } from "react";
import {
  Badge,
  Col,
  FloatingLabel,
  Form,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import SmsTextBox from "../../components/generic/_SmsTextBox";
import EmailTextBox from "../../components/generic/_EmailTextBox";
import PropTypes from "prop-types";
import ShortlinksList from "../Generic/_ShortlinksList";
import WhatsappMessageEdit from "./_WhatsappMessageEdit";

const CampaignMessageEdit = ({
  isSMS,
  isWhatsApp,
  values,
  onChange,
  listShortLinks,
  fieldsInfo,
  clickLink,
  setValues,
  onChangeWhatsappMessage,
  isEmail,
  cleanWhatsappParameters,
  isDisabled = false,
  onChangeWhatsappTemplate,
}) => {
  const [activeTab, setActiveTab] = useState(
    isWhatsApp ? "AddFields" : "ShortLinks"
  );

  useEffect(() => {
    // Update the active tab whenever isWhatsApp changes
    setActiveTab(isWhatsApp ? "AddFields" : "ShortLinks");
  }, [isWhatsApp]);

  return (
    <>
      <Row>
        {isWhatsApp && (
          <WhatsappMessageEdit
            onChangeWhatsappMessage={onChangeWhatsappMessage}
            defaultValue={values.message}
            name="message"
            cleanWhatsappParameters={cleanWhatsappParameters}
            valueParameters={values.parameters}
            changeHandler={onChange}
            onChangeWhatsappTemplate={onChangeWhatsappTemplate}
          ></WhatsappMessageEdit>
        )}

        {isEmail && (
          <>
            {" "}
            <Col sm={12}>
              <div>
                <FloatingLabel label="Asunto" className="mb-3">
                  <Form.Control
                    type="text"
                    name="subject"
                    id="Asunto"
                    value={values.subject}
                    required
                    onChange={(event) => {
                      onChange(event);
                    }}
                    placeholder="Ingrese un Asunto"
                  />
                </FloatingLabel>
              </div>
            </Col>
            <Col sm={12}>
              <div style={{ height: isSMS ? "250px" : "400px" }}>
                <EmailTextBox
                  name="message"
                  defaultValue={values.message}
                  changeHandler={onChange}
                ></EmailTextBox>
              </div>
            </Col>
          </>
        )}
        {isSMS && (
          <Col sm={12}>
            <div style={{ height: isSMS ? "250px" : "400px" }}>
              <SmsTextBox
                name="message"
                defaultValue={values.message}
                changeHandler={onChange}
                isDisabled={isDisabled}
              ></SmsTextBox>
            </div>
          </Col>
        )}

        <Col sm={12}>
          <Tabs
            // activeKey={isWhatsApp ? "AddFields" : "ShortLinks"}
            activeKey={activeTab}
            id="fill-tab-example"
            onSelect={(k) => setActiveTab(k)}
            className="tabsBottom"
            fill
          >
            {!isWhatsApp && (
              <Tab eventKey="ShortLinks" title="Urls Cortas">
                {listShortLinks && (
                  <div className="ShortLink" style={{ paddingTop: "10px" }}>
                    <h6>
                      Al darle click se agregará la url corta relacionada con el
                      alias que aparece a continuación:
                    </h6>
                    <div className="AllLinks">
                      <>
                        {listShortLinks && (
                          <ShortlinksList
                            clickBadge={clickLink}
                            listShortLinks={listShortLinks}
                          />
                        )}
                      </>
                    </div>
                  </div>
                )}
              </Tab>
            )}

            <Tab eventKey="AddFields" title="Template">
              <div className="ShortLink" style={{ paddingTop: "10px" }}>
                <h6>
                  Al darle click se agregará el campo relacionado con el alias
                  que aparece a continuación:
                </h6>
                <div className="AllLinks">
                  <>
                    {fieldsInfo &&
                      fieldsInfo.map((field) => {
                        return (
                          <>
                            <Badge
                              onClick={() => {
                                //   setMessageText(field.vc_keycolumn);
                                setValues({
                                  ...values,
                                  message:
                                    values.message +
                                    " {" +
                                    field.vc_keycolumn +
                                    "} ",
                                  parameters:
                                    (values.parameters
                                      ? values.parameters + " ,"
                                      : "") +
                                    field.vc_keycolumn +
                                    " ",
                                });
                              }}
                              bg="primary"
                            >
                              {field.vc_keycolumn}
                            </Badge>
                          </>
                        );
                      })}
                  </>
                </div>
              </div>
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

CampaignMessageEdit.propTypes = {
  isSMS: PropTypes.bool.isRequired,
  isEmail: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  listShortLinks: PropTypes.array.isRequired,
  fieldsInfo: PropTypes.array.isRequired,
  clickLink: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  isWhatsApp: PropTypes.bool.isRequired,
  cleanWhatsappParameters: PropTypes.func.isRequired,
  onChangeWhatsappMessage: PropTypes.bool.isRequired,
  onChangeWhatsappTemplate: PropTypes.func.isRequired,
};

export default CampaignMessageEdit;
